import { Box, Button, Typography, useTheme, useMediaQuery, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import axios from 'axios';
import { Tooltip } from '@mui/material';
import { AuthContext } from '../../context/AuthContext';
import { useContext, useEffect, useState } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import SettingsIcon from '@mui/icons-material/Settings';

const Order = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [suppliers, setSuppliers] = useState(null);
  const { currentuser, base_url } = useContext(AuthContext);
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [pdfUrl, setPdfUrl] = useState('');
  const [remark, setRemark] = useState('');
  const [showRemarkField, setShowRemarkField] = useState(false);
  let { id } = useParams();

  const config = {
    headers: {
      'Authorization': `Bearer ${currentuser.token}`
    },
    responseType: 'blob',
  };

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${base_url}/ethioglobal/docs/pdf/Shentam.pdf`, config);
      
      const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      setPdfUrl(pdfUrl);
    } catch (error) {}
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchSuppliers = async () => {
    try {
      const response = await axios.post(`${base_url}/ethioglobal/suppliers/all`, config);
      setSuppliers(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  const handleApprove = async () => {
    await axios.post(base_url + '/ethioglobal/supplier/approve', {id: id}, config).then((res) => {
      alert('Approved.');
    }).catch((error) => {
      if(error.status == 404){
        alert('Supplier not found.');
      } else {
        alert('An error occurred.');
      }
    });
  };

  const handleReject = () => {
    setShowRemarkField(true);
  };

  const handleRemarkSubmit = () => {
    console.log("Remark submitted:", remark);
    // You can add logic here to handle the remark submission
    setShowRemarkField(false); // Optionally hide the remark field again
    setRemark(''); // Clear the remark field
  };

  return (
    <Box m="20px">
      {pdfUrl ? (
        <Box mt="20px">
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography>
                Company name:
                <Link to={`/supplier/9`} style={{ textDecoration: 'underline', color: '#1976d2', marginLeft: '14px' }}>
                  Tekalign
                </Link>
              </Typography>
              <Box>
                <Button variant="contained" color="primary" onClick={handleApprove} sx={{ marginRight: 1 }}>
                  Approve
                </Button>
                <Button variant="contained" color="secondary" onClick={handleReject}>
                  Reject
                </Button>
              </Box>
            </Box>
            {showRemarkField && (
              <Box mt={2}>
                <TextField
                  label="Remark"
                  multiline
                  rows={4}
                  variant="outlined"
                  fullWidth
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
                <Button variant="contained" color="primary" onClick={handleRemarkSubmit} sx={{ marginTop: 1, marginRight: '20px' }}>
                  Submit Remark
                </Button>
                <Button variant="contained" color="primary" onClick={() => setShowRemarkField(false)} sx={{ marginTop: 1 }}>
                  Cancel
                </Button>
              </Box>
            )}
            <Box sx={{ border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden', marginTop: 1 }}>
              <iframe
                  src={pdfUrl}
                  style={{ width: '100%', height: '500px', border: 'none' }}
                  title="Uploaded PDF"
                  onLoad={() => console.log("PDF Loaded")}
                  onError={() => console.error("Error loading PDF")}
              />
            </Box>
        </Box>
      )
      :
      <Box>
        <Typography>The supplier didn't upload any documents yet.</Typography>
      </Box>
      }
    </Box>
  );
};

const overflowCellStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export default Order;